export interface CustomFont {
  label: string
  value: string
  url: string
  weights?: number[]
}
export const unlayerCustomFonts: CustomFont[] = [
  {
    label: 'Barlow',
    value: "'Barlow Condensed', Arial, Helvetica, sans-serif",
    url: 'https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@100;200;300;400;500;600;700;800;900',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    label: 'Rethink Sans',
    value: "'Rethink Sans', Arial, Helvetica, sans-serif",
    url: 'https://fonts.googleapis.com/css2?family=Rethink+Sans:wght@100;200;300;400;500;600;700;800;900',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
]

// Brand fonts scoped to a single merchant, keyed by merchant handle.
export const merchantCustomFonts: Record<string, CustomFont[]> = {
  awrestaurants: [
    {
      label: 'Karmina Sans',
      value: "'Karmina Sans', 'Century Gothic', Futura, Arial, sans-serif",
      url: 'https://d1vy8m0n28c6ni.cloudfront.net/fonts/email-builder/awrestaurants/v1/fonts.css',
      weights: [900],
    },
    {
      label: 'Paul Slab Soft',
      value: "'Paul Slab Soft', 'Century Gothic', Futura, Arial, sans-serif",
      url: 'https://d1vy8m0n28c6ni.cloudfront.net/fonts/email-builder/awrestaurants/v1/fonts.css',
      weights: [700],
    },
    {
      label: 'TT Fors',
      value: "'TT Fors', 'Century Gothic', Futura, Arial, sans-serif",
      url: 'https://d1vy8m0n28c6ni.cloudfront.net/fonts/email-builder/awrestaurants/v1/fonts.css',
      weights: [400, 700],
    },
  ],
}

export function unlayerCustomFontsFor(handle?: string): CustomFont[] {
  if (!handle || !merchantCustomFonts[handle]) return [...unlayerCustomFonts]
  return [...unlayerCustomFonts, ...merchantCustomFonts[handle]]
}
